import * as React from "react";
import { classNames } from "src/services/theme";

interface Props {
    className?: string;
    title?: string;
    align?: 'left' | 'right';
    color?: 'blue' | 'orange';
}

interface State {
    open: boolean;
}

export default class Tooltip extends React.Component<Props, State> {
    render() {
        const { children, title, align = 'left', color = 'orange' } = this.props;
        const { } = this.state;
        
        return (
          <span className={classNames('UI_Tooltip')}>
            <div className={classNames(align, color)}>{title}</div>
            {children}
          </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/Tooltip.tsx